import {Country} from "@pg-rp/common-types";

export const gtmEcommerceCountryMap = {
    [Country.POLAND]: "Polska",
    [Country.SPAIN]: "Hiszpania"
};

export const getGtmEcommerceCountry = (country?: Country) => {
    const requestedCountry = country || Country.POLAND;
    return gtmEcommerceCountryMap[requestedCountry];
};
import {Country} from "@pg-rp/common-types";

export const gtmEcommerceCountryMap = {
    [Country.POLAND]: "Polska",
    [Country.SPAIN]: "Hiszpania"
};

export const getGtmEcommerceCountry = (country?: Country) => {
    const requestedCountry = country || Country.POLAND;
    return gtmEcommerceCountryMap[requestedCountry];
};
